module.exports = __webpack_public_path__ + "img/slide3.19068a60.png";